const findNearestTextNode = (element) => {
  if (!element) return null;

  if (element.nodeType === Node.TEXT_NODE) {
    return element;
  }

  for (let i = 0; i < element.childNodes.length; i++) {
    const node = findNearestTextNode(element.childNodes[i]);

    if (node) {
      return node;
    }
  }

  return null;
};

const arrowDownInTitle = (editorRef, cursorX, focusFn) => {
  // get the Y position of the first line in the editor
  const editorElement = editorRef.$el;
  const firstNode = editorElement.querySelector('.ProseMirror *:first-child');
  const firstTextNode = findNearestTextNode(firstNode);
  const firstElement = firstTextNode?.parentElement || firstNode;
  const { top } = firstElement.getBoundingClientRect();

  // calculate the middle Y coordinate of the first line
  const { lineHeight } = window.getComputedStyle(firstElement);
  const firstLineY = top + parseInt(lineHeight, 10) / 2;

  const posAtCoords = editorRef.editor.view.posAtCoords({
    left: cursorX,
    top: firstLineY,
  });

  const coordsAtPos = editorRef.editor.view.coordsAtPos(posAtCoords.pos);

  const positionNotInFirstRow = top + parseInt(lineHeight, 10) < coordsAtPos.top;

  focusFn(positionNotInFirstRow ? posAtCoords.pos - 1 : posAtCoords.pos);
};

const createDivDuplicateOfTextarea = (element) => {
  const { top, left, bottom, width } = element.getBoundingClientRect();
  const { fontSize, lineHeight, letterSpacing, fontWeight } = window.getComputedStyle(element);
  const textAreaDiv = document.createElement('div');
  textAreaDiv.style.cssText = `
    position: absolute;
    top: ${top}px;
    color: transparent;
    left: ${left}px;
    width: ${width}px;
    font-size: ${fontSize};
    line-height: ${lineHeight};
    letter-spacing: ${letterSpacing};
    font-weight: ${fontWeight};
  `;
  textAreaDiv.textContent = element.value;

  return {
    div: textAreaDiv,
    left,
    lastLineY: bottom - parseInt(lineHeight, 10) / 2,
  };
};

const getCaretRangeFromPoint = (x, y) => {
  if (!document.caretRangeFromPoint) {
    const range = document.createRange();
    const sel = window.getSelection();
    range.setStart(sel.anchorNode, sel.anchorOffset);
    range.collapse(true);
    const { offsetNode, offset } = document.caretPositionFromPoint(x, y);
    range.setEnd(offsetNode, offset);
    return range;
  }
  return document.caretRangeFromPoint(x, y);
};

const arrowUpInFirstRowOfEditor = (titleRef, { rect }) => {
  const [pageTitleInput] = titleRef.$el.getElementsByTagName('textarea');

  // create a div that is a duplicate of the textarea
  const { div, lastLineY, left } = createDivDuplicateOfTextarea(pageTitleInput);
  document.body.appendChild(div);

  const offsetLeft = left === rect.left ? rect.left + 5 : rect.left;

  const { startOffset } = getCaretRangeFromPoint(offsetLeft, lastLineY) || {};

  // remove textareadiv from dom
  document.body.removeChild(div);

  // set caret position in pageTitleInput to startOffset
  pageTitleInput.focus();
  if (startOffset) {
    pageTitleInput.setSelectionRange(startOffset, startOffset);
  }
};

const arrowLeftAtEditorStart = (titleRef) => {
  const [pageTitleInput] = titleRef.$el.getElementsByTagName('textarea');
  const textLength = pageTitleInput.value.length;

  // focus on text area on last position
  pageTitleInput.focus();
  pageTitleInput.setSelectionRange(textLength, textLength);
};

export { arrowDownInTitle, arrowUpInFirstRowOfEditor, arrowLeftAtEditorStart };
